import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const reasons = [
  { icon: 'FiAward', title: 'Experienced professionals', text: 'A trained team with the skill and care to get the details right.' },
  { icon: 'FiDroplet', title: 'Premium products', text: 'Carefully selected products chosen for quality and performance.' },
  { icon: 'FiHeart', title: 'Personalised service', text: 'Thoughtful consultations that begin with what matters to you.' },
  { icon: 'FiShield', title: 'Clean & hygienic salon', text: 'A tidy, comfortable space with hygiene in every appointment.' }
];

function WhyUs() {
  return (
    <section className="section why-section">
      <div className="container">
        <Reveal><SectionHeading eyebrow="The Saffron & Sage difference" title="Good service is in the details." description="A lovely result matters. So does how you feel getting there." centered /></Reveal>
        <div className="reasons-grid">
          {reasons.map((reason, index) => {
            const Icon = FiIcons[reason.icon];
            return <Reveal className="reason-card" key={reason.title} delay={index * 0.07}>
              <span className="reason-icon"><SafeIcon icon={Icon} /></span><span className="reason-number">0{index + 1}</span>
              <h3>{reason.title}</h3><p>{reason.text}</p>
            </Reveal>;
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyUs;
